import React, { useEffect, useState } from "react";
import PaymentInformationForm from "./PaymentInformationForm";
import { RecurlyElements } from "@/components/RecurlyElements";
import PlanLayout from "../PlanLayout";

export default function PaymentInformationPage() {
  return <>
    <PlanLayout>
      <RecurlyElements>
        <PaymentInformationForm />
      </RecurlyElements>
    </PlanLayout>
  </>;
}
